import { SpaceBetween } from "@cloudscape-design/components-themed";
import { UpdateInfo } from "../components/gw-contract-register/UpdateInfo";
import { USER_TYPE, PERMISSIONS } from "../configs/constants";
import { useCanIShowHook } from "../app/useCanIShowHook";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const GwContractsUpdate = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.GW);
  // 事業者種別取得
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  return <SpaceBetween size="l">{isDocomoUser && <UpdateInfo />}</SpaceBetween>;
};

export default GwContractsUpdate;
